// BarChartComponent.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface IProps {
    Data: any;
}

const RatingStaticsComponent = (props: IProps) => {
    return (
        <ResponsiveContainer width="100%" height={300} >
            <BarChart
                data={props.Data}
                margin={{ top: 20, right: 50, left: 0, bottom: 5 }}
                width={15}
            >
                <CartesianGrid strokeDasharray="0" vertical={false} />
                <XAxis dataKey="name" axisLine={false} tickLine={false} />
                <YAxis axisLine={false} tickLine={false} />
                <Tooltip
                    contentStyle={{
                        backgroundColor: "#fff",
                        color: "black",
                        fontWeight: "bold",
                        borderRadius: "4px"
                    }}
                />
                <Bar
                    dataKey="Users"
                    fill="#FFAE0D"
                    barSize={50}
                    opacity={props.Data.opacity}
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default RatingStaticsComponent;
